import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { isOnMainProductPage } from '@theme/utilities';

class ProductStatus extends HTMLElement {
  /** @type {AbortController | null} */
  #abortController = null;

  connectedCallback() {
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;

    if (isOnMainProductPage(this)) {
      // On main product page, only listen at document level to avoid duplicate events
      // (events bubble from section to document, causing double-firing)
      document.addEventListener(ThemeEvents.variantUpdate, this.#updateStatus, { signal });
    } else {
      // In modals, dialogs, etc., listen at the container level
      const closestSection = this.closest('.shopify-section, dialog');
      closestSection?.addEventListener(ThemeEvents.variantUpdate, this.#updateStatus, { signal });
    }
  }

  disconnectedCallback() {
    this.#abortController?.abort();
    this.#abortController = null;
  }

  /**
   * @param {VariantUpdateEvent} event
   */
  #updateStatus = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = String(event.detail.data.newProduct.id);
    } else if (event.detail.data.productId !== this.dataset.productId) {
      return;
    }

    const newStatus = event.detail.data.html?.querySelector('product-status');

    if (!newStatus) return;

    // Use innerHTML instead of morph - simpler and more reliable for this case
    // Handles empty content (no status) correctly
    if (this.innerHTML !== newStatus.innerHTML) {
      this.innerHTML = newStatus.innerHTML;
    }
  };
}

if (!customElements.get('product-status')) {
  customElements.define('product-status', ProductStatus);
}

